module.exports = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = window.location.origin + '/mfe/referrals/remoteEntry.js';
            script.onload = () => { resolve(window['referrals']); };
            script.onerror = () => { resolve({ get: () => Promise.resolve(() => () => 'Module referrals unavailable'), init: () => {} }); };
            document.head.appendChild(script);
        });